import React from 'react';
import { BasicForm, SelectFormItem } from 'ui-lib';
import { TextFieldItem, IconTextButton, useForm, } from 'ui-lib';
import repositoryCss from './repository.css';
import { useAccountStore, useAuthStore } from 'store';
import { RepositoryDto, RepositoryType } from 'dto/repository.dto';
import { AccountType } from 'dto/access-management/account-dto';
import { observer } from 'mobx-react';
import { useRepositoryPermissionContext } from 'contexts/permissions/repository-permission.context';

export interface ISubmitProps {
    label: string;
    type?: RepositoryType;
    description: string;
}

export interface IRepositoryDetailProps {
    repository?: RepositoryDto;
    label: string;
    submitButtonLabel: string;
    repositoryTypeSelectAble?: boolean;
    onSubmit: (repository: ISubmitProps) => void;
    onClose: () => void;
}

export const DPU_REPOSITORY_TYPES_SOURCE = [
    { value: 'ALM', label: 'ALM' },
    { value: 'SCR', label: 'SCR' },
    { value: 'VOS', label: 'VOS' },
];

export const RepositoryDetail = observer((props: IRepositoryDetailProps) => {
    const { currentUser } = useAuthStore();
    const accountStore = useAccountStore();
    const { canModify: hasModifyPermission } = useRepositoryPermissionContext();
    const [form] = useForm();
    const [label, setLabel] = React.useState(props.repository ? props.repository.label : '');
    const [description, setDescription] = React.useState(props.repository ? props.repository.description : '');
    const [repositoryType, setRepositoryType] = React.useState<RepositoryType>(props.repository ? props.repository.type
        : currentUser.accountType === AccountType.DPU ? RepositoryType.ALM
            : currentUser.accountType as RepositoryType);

    const accountName = accountStore.findAccount(currentUser.accountId).name;

    const handleSubmit = (values: any) => {
        props.onSubmit({
            label: label,
            type: repositoryType,
            description: description,
        });
    };

    return (
        <React.Fragment>
            <h2>{props.label}</h2>
            <BasicForm
                title={props.label}
                form={form}
                onSubmit={handleSubmit}
                className={repositoryCss['transfer-form']}
                items={[
                    <TextFieldItem
                        key='organisation'
                        code='organisation'
                        label='Organisation'
                        colon={true}
                        labelAlign='right'
                        initialValue={accountName}
                        disabled={true}
                    />,
                    <TextFieldItem
                        key='repositorLabel'
                        code='repositorLabel'
                        label='Repository Label'
                        colon={true}
                        isRequired={true}
                        labelAlign='right'
                        initialValue={label}
                        disabled={!hasModifyPermission}
                        onChange={(value) => setLabel(value.target.value)}
                    />,
                    (currentUser.accountType === AccountType.DPU) && <SelectFormItem
                        code='repositoryType'
                        label='Type'
                        colon={true}
                        isRequired={true}
                        labelAlign='right'
                        dataSource={DPU_REPOSITORY_TYPES_SOURCE}
                        selectedValue={repositoryType}
                        onChange={(value) => setRepositoryType(value)}
                        disabled={!props.repositoryTypeSelectAble || !hasModifyPermission}
                    />,
                    <TextFieldItem
                        key='description'
                        code='description'
                        label='Description'
                        colon={true}
                        isRequired={false}
                        disabled={!hasModifyPermission}
                        labelAlign='right'
                        initialValue={description}
                        onChange={(value) => setDescription(value.target.value)}
                    />,
                    <div className={repositoryCss['row']}>
                        <IconTextButton
                            key='back-button'
                            className={repositoryCss['footer-left-button']}
                            htmlType='button'
                            label='Back'
                            onClick={props.onClose}
                        />
                        <IconTextButton
                            key='submit-button'
                            className={repositoryCss['footer-right-button']}
                            htmlType='submit'
                            disabled={!hasModifyPermission}
                            label={props.submitButtonLabel}
                            type='primary'
                        />
                    </div>,
                ]}
            />
        </React.Fragment>
    );
});
